import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import logo from "../img/logo.png";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBInput,
} from "mdb-react-ui-kit";

const ClubLogin = ({ condition }) => {
  const [step, setStep] = useState(1); // 1: Selection & Mobile, 2: OTP Verification
  const [districts, setDistricts] = useState([]);
  const [clubs, setClubs] = useState([]);
  
  const [selectedDist, setSelectedDist] = useState("");
  const [selectedClubId, setSelectedClubId] = useState("");
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [errMsg, setErrMsg] = useState("");

  const API_BASE = "https://lionsdirectoryapi.emedha.in/club/api";

  // Fetch approved districts on mount
  useEffect(() => {
    fetchApprovedDistricts();
  }, []);

  const fetchApprovedDistricts = async () => {
    try {
      const res = await axios.get(`${API_BASE}/approved-districts`);
      setDistricts(res.data);
    } catch (error) {
      console.error("Error fetching districts:", error);
      setErrMsg("Failed to load districts.");
    }
  };

  // Triggered when dynamic district changes
  const handleDistChange = async (distValue) => {
    setSelectedDist(distValue);
    setSelectedClubId("");
    setClubs([]);
    setErrMsg("");
    
    if (!distValue) return;

    try {
      const res = await axios.post(`${API_BASE}/get-clubs`, { dist: distValue });
      setClubs(res.data);
    } catch (error) {
      console.error("Error fetching clubs:", error);
      setErrMsg("Failed to load clubs for the selected district.");
    }
  };

  // Step 1: Request OTP Handshake
  const handleSendOtp = async () => {
    setErrMsg("");
    if (!selectedDist || !selectedClubId || !mobile) {
      setErrMsg("Please select District, Club and enter your Mobile Number.");
      return;
    }

    try {
      const res = await axios.post(`https://lionsdirectoryapi.emedha.in/club/api/send-club-otp`, {
        clubId: selectedClubId,
        mobile: mobile,
        dist: selectedDist
      });

      if (res.data.success) {
        setStep(2);
      } else {
        setErrMsg(res.data.message || "Failed to send OTP.");
      }
    } catch (error) {
      setErrMsg(error.response?.data?.message || "An error occurred. Try again.");
    }
  };

  // Step 2: Validate Verification Token 
  const handleVerifyOtp = async () => {
    setErrMsg("");
    if (!otp) {
      setErrMsg("Please enter the 6-digit verification code.");
      return;
    }

    try {
      const res = await axios.post(`${API_BASE}/verify-club-otp`, {
        clubId: selectedClubId,
        mobile: mobile,
        dist: selectedDist,
        otp: otp
      });

      if (res.data.success) {
        alert("Login Successful!");
        

        sessionStorage.setItem("id", res.data.clubId);
        sessionStorage.setItem("clubNumber", res.data.clubNumber);
        sessionStorage.setItem("clubName", res.data.clubName);
        sessionStorage.setItem("dist", res.data.dist);
        sessionStorage.setItem("officerName", res.data.officerName);
        sessionStorage.setItem("officerRole", res.data.officerRole); // Stores "President" or "Secretary"
        sessionStorage.setItem("mobile", res.data.mobile);
        sessionStorage.setItem("role", "clubAdmin");

        if (condition) condition(res.data.clubId);
      } else {
        setErrMsg(res.data.message || "Invalid OTP code.");
      }
    } catch (error) {
      setErrMsg(error.response?.data?.message || "Verification failed.");
    }
  };

  return (
    <div style={{ backgroundColor: "#1a1a2e", minHeight: "100vh" }}>
      <br /><br /><br /><br />
      <MDBContainer fluid>
        <MDBRow className="d-flex justify-content-center align-items-center h-100">
          <MDBCol col="12">
            <MDBCard
              className="bg-warning text-white my-1 mx-auto"
              style={{ 
                borderRadius: "1.5rem", 
                maxWidth: "430px",
                background: "linear-gradient(135deg, #ffc107 0%, #ff9800 100%)",
                boxShadow: "0px 15px 35px rgba(0,0,0,0.5)"
              }}
            >
              <MDBCardBody className="p-5 d-flex flex-column align-items-center mx-auto w-100">
                
                {/* Logo Frame */}
                <h2 className="fw-bold mb-3 text-uppercase">
                  <img
                    src={logo}
                    height="80px"
                    width="80px"
                    className="logo1"
                    alt="Lions Logo"
                    style={{ filter: "drop-shadow(0px 4px 8px rgba(0,0,0,0.3))" }}
                  />
                </h2>
                
                <h4 className="mb-2 text-uppercase fw-bold text-dark" style={{ letterSpacing: "1.5px" }}>
                  Club Portal
                </h4>
                <p className="text-dark border-bottom border-dark pb-3 mb-4 w-100 text-center" style={{ opacity: 0.85 }}>
                  {step === 1 ? "Secure Member Access Verification" : "Enter Verification Code"}
                </p>

                {/* Unified Error Alert Banner */}
                {errMsg && (
                  <div className="alert alert-danger w-100 text-center py-2 mb-4 small fw-bold" style={{ borderRadius: "0.5rem" }}>
                    {errMsg}
                  </div>
                )}

                {step === 1 ? (
                  <>
                    {/* District Dropdown: Mapped dynamically using 'district' field */}
                    <select
                      className="form-select mb-4 py-2.5 shadow-sm"
                      style={{ borderRadius: "0.5rem", border: "1px solid #ced4da" }}
                      value={selectedDist}
                      onChange={(e) => handleDistChange(e.target.value)}
                    >
                      <option value="">Select District</option>
                      {districts.map((d, index) => (
                        <option key={index} value={d.district}>
                          District {d.district} ({d.name})
                        </option>
                      ))}
                    </select>

                    {/* Club Selection Dropdown */}
                    <select
                      className="form-select mb-4 py-2.5 shadow-sm"
                      style={{ borderRadius: "0.5rem", border: "1px solid #ced4da" }}
                      value={selectedClubId}
                      disabled={!selectedDist}
                      onChange={(e) => setSelectedClubId(e.target.value)}
                    >
                      <option value="">Select Club</option>
                      {clubs.map((c) => (
                        <option key={c.clubId} value={c.clubId}>
                          {c.clubName} ({c.clubNumber})
                        </option>
                      ))}
                    </select>

                    {/* Mobile Input Field */}
                    <MDBInput
                      wrapperClass="mb-4 w-100 text-dark"
                      placeholder="Registered Mobile Number"
                      type="tel"
                      size="lg"
                      maxLength={10}
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                      style={{ borderRadius: "0.5rem", backgroundColor: "#fff" }}
                    />

                    <button 
                      className="btn btn-danger  mx-5 w-100 py-2.5 fw-bold text-uppercase shadow" 
                      style={{ borderRadius: "0.5rem",  letterSpacing: "1px" }}
                      onClick={handleSendOtp}
                    >
                      Send WhatsApp OTP
                    </button>
                  </>
                ) : (
                  <>
                    <div className="text-center mb-3 text-dark small">
                      An access verification token has been dispatched to WhatsApp line: <strong>+91 {mobile}</strong>
                    </div>

                    <MDBInput
                      wrapperClass="mb-4 w-100 text-dark"
                      placeholder="Enter 6-Digit OTP"
                      type="text"
                      size="lg"
                      maxLength={6}
                      value={otp}
                      onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                      style={{ borderRadius: "0.5rem", backgroundColor: "#fff", textClassName: "center", fontSize: "1.25rem", letterSpacing: "4px" }}
                    />

                    <button 
                      className="btn btn-success mx-5 w-100 py-2.5 fw-bold text-uppercase shadow mb-3" 
                      style={{ borderRadius: "0.5rem", letterSpacing: "1px" }}
                      onClick={handleVerifyOtp}
                    >
                      Verify & Access Dashboard
                    </button>

                    <span 
                      className="text-dark text-decoration-underline fw-bold context-link" 
                      style={{ cursor: "pointer", fontSize: "0.9rem" }}
                      onClick={() => setStep(1)}
                    >
                      ← Modify Details
                    </span>
                  </>
                )}
{/* 
                <p className="mt-4 mb-0 text-dark small">
                  Management Credentials Needed?{" "}
                  <Link to="/admin-login">
                    <strong style={{ color: "#002060" }}>Admin Login</strong>
                  </Link>
                </p> */}
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
};

export default ClubLogin;